import React from 'react';

import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Card, CardContent } from '@tmap/mmm-style-guide/src/Card';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { toKey, types } from '@tmap/mmm-core/entityKey';
import { isStatusBefore, UserListItemStatus } from '@tmap/mmm-core/commonApp/userListItemStatus';

import analytics from '../../lib/analytics';
import getApplicationStartURL from '../../lib/commonApp/getApplicationStartURL';
import useUserListItem from '../../hooks/useUserListItem';
import useRequireAuth from '../../hooks/useRequireAuth';

const EligibilityCard = styled(Card)(({ theme }) => ({
  margin: theme.spacing(3, 0),
  padding: theme.spacing(1),
  borderRadius: '8px',
  background: theme.palette.grey[100],
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  paddingBottom: `${theme.spacing(2)} !important`,
}));

const EligibilityButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

function EligibilityChecker(props) {
  const { incentive } = props;

  const { requireAuthRedirect } = useRequireAuth();
  const userListItem = useUserListItem({ incentive });
  const enabled = userListItem
    ? isStatusBefore(userListItem.status, UserListItemStatus.APPLIED)
    : true;

  const handleContinue = () => {
    if (!enabled) return;
    requireAuthRedirect(
      getApplicationStartURL(userListItem, toKey(types.INCENTIVE, incentive._id)),
    );
    analytics.track('claim', {
      entityKey: toKey('incentive', incentive._id),
    });
  };

  return (
    <EligibilityCard elevation={0}>
      <StyledCardContent>
        <Typography variant='subtitle2' fontWeight={500}>Not sure if you qualify for this program?</Typography>
        <Typography variant='body2' marginTop={0.5} sx={{ maxWidth: '420px' }}>
          We make it simple to find out which programs you qualify for.
          The application process starts with a quick eligibility check,
          and we won&apos;t waste your time if it&apos;s not a good fit.
        </Typography>
        {!enabled && (
          <Typography variant='body2' color='textSecondary' marginTop={1}>You already completed an application for this program.</Typography>
        )}
        <EligibilityButton variant='outlined' color='inverted' onClick={handleContinue} disabled={!enabled}>Determine Eligibility</EligibilityButton>
      </StyledCardContent>
    </EligibilityCard>
  );
}

export default EligibilityChecker;
